import { render } from "./Thongkebenhnhan.vue?vue&type=template&id=b49f608e&scoped=true&ts=true"
import script from "./Thongkebenhnhan.vue?vue&type=script&lang=ts"
export * from "./Thongkebenhnhan.vue?vue&type=script&lang=ts"

import "./Thongkebenhnhan.vue?vue&type=style&index=0&id=b49f608e&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DieuTri/DieuTri/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b49f608e"]])

export default __exports__